import { createSlice } from '@reduxjs/toolkit'

const initialCategoryState = {
  categoriesDropdown: [],
  isGlobalTemplateAPIcalling: false
}

export const categorySlices = createSlice({
  name: 'categories',
  initialState: initialCategoryState,
  reducers: {
    categoryList: (state, action) => {
      state.categoriesDropdown = action.payload.categories
    },
    setIsGlobalTemplateAPIcalling: (state, action) => {
      state.isGlobalTemplateAPIcalling = action.payload;
    },
  },
})